import {
  IonIcon, IonImg, IonPage, IonText,
  IonTitle,
} from '@ionic/react';
import classNames from 'classnames';
import { chevronBackOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import articlesImg from '@/assets/icons/reading.svg';
import LearningCard from '@/components/learning/LearningCard/LearningCard';
import { ROUTES_PATH } from '@/constants';
import {
  ArticleResponse,
} from '@/interfaces/LearningInterface/LearningInterface';

import styles from './AllArticles.module.scss';

export default function AllArticles() {
  const history = useHistory();

  const [articleList, setarticleList] = useState<ArticleResponse[]>([]);

  const getArticlesFromApi = async () => {
    try {
      const response = await fetch(
        'https://pepperfinance.es/wp-json/wp/v2/posts/?per_page=20&categories=29&orderby=modified&order=desc',
      );
      const responseJson = await response.json();
      setarticleList(responseJson);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getArticlesFromApi();
  }, []);
  return (
    <IonPage>
      <div className={styles.allArticlesPage}>
        <div className={styles.titleWrapper}>
          <Link className={styles.backBtn} to={ROUTES_PATH.LEARNING}>
            <IonIcon slot="start" icon={chevronBackOutline} />
            Volver a formación
          </Link>
        </div>
        <div className={styles.contentWrapper}>
          <IonTitle className={styles.allArticlesTitle}>Formación</IonTitle>
          <div className={styles.headerDivider} />
          <div className={styles.submenuWrapper}>
            <IonText className={styles.submenuText}>
              <IonImg src={articlesImg} className={styles.submenuImg} />
              Artículos
            </IonText>
            <IonText className={styles.submenuOtherText}>
              Las últimas noticias y novedades para que estés siempre al día en
              nuestros servicios.
            </IonText>
          </div>
          <div className={styles.articlesSection}>
            <div className={classNames(styles.articlesWrapper, styles.allArticles)}>
              {articleList.map((article: ArticleResponse, index) => (
                <LearningCard
                  key={index}
                  title={article.title?.rendered}
                  subtitle={article.excerpt?.rendered}
                  imgUrl={article.fimg_url}
                  description={article.yoast_head_json.og_description}
                  cardClick={() => {
                    history.push({
                      pathname: `${ROUTES_PATH.ARTICLE_DETAIL}/${article.id}`,
                      state: article,
                    });
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </IonPage>
  );
}
